import "moment/locale/it"
import { CompetitionSeasonPlayerCompetitionSeasonParameterFlat } from "../../../types/competitionSeasonPlayerStats"
import { PlayerRole } from "../../../types/player"
import { PlayerCompetitionSeasonStatsForward } from "@components/CompetitionSeasonStats/PlayerCompetitionSeasonStatsForward"
import { PlayerCompetitionSeasonStatsGoalkeeper } from "@components/CompetitionSeasonStats/PlayerCompetitionSeasonStatsGoalkeeper"
import { PlayerCompetitionSeasonStatsDefender } from "@components/CompetitionSeasonStats/PlayerCompetitionSeasonStatsDefender"
import { PlayerCompetitionSeasonStatsMidfielder } from "@components/CompetitionSeasonStats/PlayerCompetitionSeasonStatsMidfielder"

export function PlayerCompetitionSeasonStats({
  role,
  stats,
}: {
  role: PlayerRole | null
  stats: CompetitionSeasonPlayerCompetitionSeasonParameterFlat
}) {
  const gamesPlayed = stats.parameters.find((parameter) => parameter.code === "PG")?.value || 0
  const minutes = stats.parameters.find((parameter) => parameter.code === "MIN")?.value || 0
  const assists = stats.parameters.find((parameter) => parameter.code === "ASS_V")?.value || 0
  const crosses = stats.parameters.find((parameter) => parameter.code === "CRS")?.value || 0
  const percentageCrosses = stats.parameters.find((parameter) => parameter.code === "CRS_X")?.value || 0
  const yellowCards = stats.parameters.find((parameter) => parameter.code === "CRT_G")?.value || 0
  const redCards = stats.parameters.find((parameter) => parameter.code === "CRT_R")?.value || 0
  const dribbling = stats.parameters.find((parameter) => parameter.code === "DRB")?.value || 0
  const duels = stats.parameters.find((parameter) => parameter.code === "DUL")?.value || 0
  const wonDuels = stats.parameters.find((parameter) => parameter.code === "DUL_VX")?.value || 0
  const contrasts = stats.parameters.find((parameter) => parameter.code === "DUL_TV")?.value || 0
  const fouls = stats.parameters.find((parameter) => parameter.code === "FAL")?.value || 0
  const concededFouls = stats.parameters.find((parameter) => parameter.code === "FAS")?.value || 0
  const goals = stats.parameters.find((parameter) => parameter.code === "GOL")?.value || 0
  const concededGoals = stats.parameters.find((parameter) => parameter.code === "GOL_S")?.value || 0
  const passes = stats.parameters.find((parameter) => parameter.code === "PAS")?.value || 0
  const shortPasses = stats.parameters.find((parameter) => parameter.code === "PAS_COR")?.value || 0
  const longPasses = stats.parameters.find((parameter) => parameter.code === "PAS_L")?.value || 0
  const percentagePasses = stats.parameters.find((parameter) => parameter.code === "PAS_X")?.value || 0
  const lostBalls = stats.parameters.find((parameter) => parameter.code === "PLP")?.value || 0
  const retrievedBalls = stats.parameters.find((parameter) => parameter.code === "PLR")?.value || 0
  const savedPenalties = stats.parameters.find((parameter) => parameter.code === "RIG_P")?.value
  const shots = stats.parameters.find((parameter) => parameter.code === "TIR")?.value || 0
  const shotsOnTarget = stats.parameters.find((parameter) => parameter.code === "TIR_SX")?.value || 0
  const percentageThroughPasses = stats.parameters.find((parameter) => parameter.code === "PAS_TX")?.value || 0
  const concededDribbling = stats.parameters.find((parameter) => parameter.code === "DRB_S")?.value || 0
  const opportunity = stats.parameters.find((parameter) => parameter.code === "BCM")?.value || 0
  const failedOpportunity = stats.parameters.find((parameter) => parameter.code === "BCC")?.value || 0
  const ducks = stats.parameters.find((parameter) => parameter.code === "DUCK")?.value || 0
  const saves = stats.parameters.find((parameter) => parameter.code === "PRT")?.value || 0
  const clearances = stats.parameters.find((parameter) => parameter.code === "CLR")?.value
  const blockShots = stats.parameters.find((parameter) => parameter.code === "TIR_SB")?.value

  let playerCompetitionSeasonStatsComponent

  switch (role) {
    case "goalkeeper":
      playerCompetitionSeasonStatsComponent = (
        <PlayerCompetitionSeasonStatsGoalkeeper
          longPasses={longPasses}
          passes={passes}
          shortPasses={shortPasses}
          percentagePasses={percentagePasses}
          savedPenalties={savedPenalties}
          concededGoals={concededGoals}
          fouls={fouls}
          redCards={redCards}
          concededFouls={concededFouls}
          yellowCards={yellowCards}
          minutes={minutes}
          ducks={ducks}
          saves={saves}
        />
      )
      break

    case "defender":
      playerCompetitionSeasonStatsComponent = (
        <PlayerCompetitionSeasonStatsDefender
          longPasses={longPasses}
          passes={passes}
          shortPasses={shortPasses}
          percentagePasses={percentagePasses}
          retrievedBalls={retrievedBalls}
          lostBalls={lostBalls}
          fouls={fouls}
          redCards={redCards}
          concededFouls={concededFouls}
          yellowCards={yellowCards}
          wonDuels={wonDuels}
          duels={duels}
          shots={shots}
          shotsOnTarget={shotsOnTarget}
          assists={assists}
          minutes={minutes}
          contrasts={contrasts}
          clearances={clearances}
          blockShots={blockShots}
          goals={goals}
          gamesPlayed={gamesPlayed}
        />
      )
      break

    default:
    case "midfielder":
      playerCompetitionSeasonStatsComponent = (
        <PlayerCompetitionSeasonStatsMidfielder
          longPasses={longPasses}
          passes={passes}
          shortPasses={shortPasses}
          percentagePasses={percentagePasses}
          goals={goals}
          fouls={fouls}
          redCards={redCards}
          concededFouls={concededFouls}
          yellowCards={yellowCards}
          wonDuels={wonDuels}
          duels={duels}
          shots={shots}
          shotsOnTarget={shotsOnTarget}
          crosses={crosses}
          percentageCrosses={percentageCrosses}
          dribbling={dribbling}
          assists={assists}
          minutes={minutes}
          contrasts={contrasts}
          clearances={clearances}
          blockShots={blockShots}
          concededDribbling={concededDribbling}
          opportunity={opportunity}
          failedOpportunity={failedOpportunity}
          gamesPlayed={gamesPlayed}
        />
      )
      break

    case "forward":
      playerCompetitionSeasonStatsComponent = (
        <PlayerCompetitionSeasonStatsForward
          longPasses={longPasses}
          passes={passes}
          shortPasses={shortPasses}
          percentagePasses={percentagePasses}
          goals={goals}
          fouls={fouls}
          redCards={redCards}
          concededFouls={concededFouls}
          yellowCards={yellowCards}
          wonDuels={wonDuels}
          duels={duels}
          shots={shots}
          shotsOnTarget={shotsOnTarget}
          crosses={crosses}
          percentageCrosses={percentageCrosses}
          dribbling={dribbling}
          assists={assists}
          minutes={minutes}
          contrasts={contrasts}
          clearances={clearances}
          blockShots={blockShots}
          concededDribbling={concededDribbling}
          gamesPlayed={gamesPlayed}
        />
      )
      break
  }

  return playerCompetitionSeasonStatsComponent
}
